import React from "react";

function Checkbox({ label, description, checked = false, className = "" }) {
  return (
    <div className={`flex flex-wrap gap-1 items-start w-full ${className}`}>
      <div className="flex gap-2 justify-center items-center w-5 min-h-[22px]">
        <div className="flex flex-col justify-center self-stretch p-0.5 my-auto w-5">
          <div className="flex shrink-0 h-4 rounded border border-gray-200 border-solid" />
        </div>
      </div>
      <div className="flex-1 shrink basis-0 min-w-60 max-md:max-w-full">
        <p className="text-sm leading-loose text-gray-700 max-md:max-w-full">
          {label}
        </p>
        {description && (
          <p className="text-xs text-zinc-600 max-md:max-w-full">
            {description}
          </p>
        )}
      </div>
    </div>
  );
}

export default Checkbox;
